import { useEffect, useState } from 'react'

export const useMinDelay = (ms: number): boolean => {
  const [done, setDone] = useState(false)
  useEffect(() => {
    const timeout = setTimeout(() => {
      setDone(true)
    }, ms)
    return () => {
      clearTimeout(timeout)
    }
  }, [ms])
  return done
}
